export const ConsumerAddressViewErrorUat = {
  error: 'workflow.consumerAddress.error.message',
}
